import styled from "styled-components";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const Veil = styled.div`
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 2;
  backdrop-filter: blur(5px);
`;

const VideoContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 25px;
  height: 0;
  z-index: 3;
`;

const Iframe = styled.iframe`
  margin: 20px;
  width: 80%;

  @media (max-width: 768px) {
    height: 345px;
  }

  @media (min-width: 768px) {
    height: 690px;
  }
`;

export default function Video() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {`
                    {
                        "@context": "https://schema.org",
                        "@type": "VideoObject",
                        "name": "Bat City Brass Band Performance",
                        "description": "Watch Bat City Brass Band perform a high-energy live set in Austin, TX",
                        "thumbnailUrl": "https://i.ytimg.com/vi/-bj1FGBn-VU/hqdefault.jpg",
                        "uploadDate": "2023-07-26",
                        "contentUrl": "https://www.youtube.com/watch?v=-bj1FGBn-VU",
                        "embedUrl": "https://www.youtube.com/embed/-bj1FGBn-VU"
                    }
                    `}
        </script>
      </Helmet>
      <Veil></Veil>
      <VideoContainer>
        <Iframe
          src="https://www.youtube.com/embed/-bj1FGBn-VU"
          title="Bat City Brass Band Performance - Live in Austin"
          aria-label="Video of Bat City Brass Band performing live"
        />
      </VideoContainer>
    </>
  );
}
